class ProductDescription extends HTMLElement {
  connectedCallback() {
    if (this._isInitialized) {
      return;
    }

    this._isInitialized = true;
    this._content = this.querySelector("[data-description-content]");
    this._toggle = this.querySelector("[data-description-toggle]");

    if (!this._content || !this._toggle) {
      return;
    }

    this._onToggle = () => this.toggleDescription();
    this._toggle.addEventListener("click", this._onToggle);

    this._resizeObserver = new ResizeObserver(() => this.updateCollapsibility());
    this._resizeObserver.observe(this._content);

    requestAnimationFrame(() => this.updateCollapsibility());
  }

  disconnectedCallback() {
    this._toggle?.removeEventListener("click", this._onToggle);
    this._resizeObserver?.disconnect();
    this._isInitialized = false;
  }

  updateCollapsibility() {
    const previewLines = Number.parseInt(this.dataset.previewLines, 10) || 4;
    const styles = getComputedStyle(this._content);
    const lineHeight = Number.parseFloat(styles.lineHeight) || Number.parseFloat(styles.fontSize) * 1.6;
    const collapsedHeight = Math.round(lineHeight * previewLines);
    const isCollapsible = this._content.scrollHeight > collapsedHeight + 4;

    this.style.setProperty("--product-description-collapsed-height", `${collapsedHeight}px`);
    this.classList.toggle("is-collapsible", isCollapsible);
    this._toggle.hidden = !isCollapsible;

    if (!isCollapsible) {
      this.setExpanded(false);
    }
  }

  toggleDescription() {
    this.setExpanded(!this.classList.contains("is-expanded"));
  }

  setExpanded(expanded) {
    this.classList.toggle("is-expanded", expanded);
    this._toggle.setAttribute("aria-expanded", expanded.toString());
    this._toggle.querySelector("[data-read-more]")?.toggleAttribute("hidden", expanded);
    this._toggle.querySelector("[data-read-less]")?.toggleAttribute("hidden", !expanded);
  }
}

if (!window.customElements.get("product-description")) {
  window.customElements.define("product-description", ProductDescription);
}
